import {
  Routes,
  Route,
  useParams,
  useNavigate,
  Navigate,
  useLocation,
} from "react-router-dom";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ListItem from "../ListItem";
import MenuPage from "../../pages/MenuPage";
import PageNotFound from "../../pages/PageNoteFound";
import CustomerProfile from "../../pages/RestaurantProfile";
import HomePage from "../../pages/HomePage";
import CartPage from "../../pages/CartPage";
import LoginPage from "../../pages/Login";
import WaiterRequest from "../../pages/WaiterRequestPage/WaiterRequest";
import PayBillPage from "../../pages/PayBill/PayBillPage";
import ReOrderPage from "../../pages/ReOrder/ReOrderPage";
import ProtectedLayout from "../../ProtectedLayout";
import OrderSuccessPage from "../../pages/OrderSuccessPage/OrderSuccessPage";
import RegistrationPage from "../../pages/Registration/RegistrationPage";
import ItemDetailPage from "../../pages/ItemDetailPage/ItemDetailPage";
import PaymentSuccessPage from "../../pages/Payment/PaymentSuccessPage";
import PaymentStatusPage from "../../pages/Payment/PaymentStatusPage";
import { fetchRestaurantLoginConfigApi } from "../../redux/api";
import TakeawayMenuPage from "../../pages/Takeaway/TakeawayMenuPage";
import TakeawayCheckout from "../../pages/Takeaway/TakeawayCheckout";
import TakeawayStatus from "../../pages/Takeaway/TakeawayStatus";

function Router() {
  const usertest = useSelector((state) => state?.user.user);
  const redirectTo = useSelector((state) => state?.user.redirectTo);
  const reduxGuestUser = useSelector((state) => state?.user.guestUser);
  const location = useLocation();
  const dispatch = useDispatch();
  const { restaurant, id, table } = useParams();
  const [activePackage, setActivePackage] = useState(
    sessionStorage.getItem("packageType") || null,
  );
  const [configLoading, setConfigLoading] = useState(true);
  // const isGuest = reduxGuestUser === true || localStorage.getItem("guestUser") === "true";
  const packageType = sessionStorage.getItem("packageType");
  //const isGuest =  packageType === "catelog" || table === "cat";
  const pathParts = location.pathname.split("/").filter(Boolean);
  const currentRestaurant = pathParts.length >= 1 ? pathParts[0] : null;
  const currentRestaurantId = pathParts.length >= 2 ? pathParts[1] : null;
  const currentTable = pathParts.length >= 3 ? pathParts[2] : null;

  // ✅ WORKS: uses currentTable from the URL and checks active state
  const resolvedPackage =
    activePackage || sessionStorage.getItem("packageType") || "";
  const isGuest =
    Boolean(reduxGuestUser) ||
    localStorage.getItem("guestUser") === "true" ||
    resolvedPackage.toLowerCase() === "catelog" ||
    currentTable?.toLowerCase() === "cat";

  useEffect(() => {
    // const pathParts = location.pathname.split("/").filter(Boolean);

    // if (pathParts.length === 3) {
    //     const restaurantId = pathParts[1];
    if (!currentRestaurantId || currentRestaurantId === "undefined") {
      setConfigLoading(false);
      return;
    }

    const fetchGlobalTheme = async () => {
      try {
        const response =
          await fetchRestaurantLoginConfigApi(currentRestaurantId);
        if (response) {
          sessionStorage.setItem(
            "customer_portal_theme",
            response.menuPortalTheme,
          );
          sessionStorage.setItem(
            "showBannerInLoginPage",
            response.showLoginPageImage,
          );
          sessionStorage.setItem("loginPageImage", response.loginPageImageURL);
          sessionStorage.setItem(
            "customer_portal_branch_id",
            currentRestaurantId,
          );
          sessionStorage.setItem("packageType", response.packageType);

          document.documentElement.setAttribute(
            "data-theme",
            response.menuPortalTheme,
          );

          setActivePackage(response.packageType);
        }
      } catch (error) {
        console.error("Global Theme Sync Error:", error);
      } finally {
        setConfigLoading(false);
      }
    };

    fetchGlobalTheme();
  }, [location.pathname]);

  function hasLoggedIn() {
    const token = localStorage.getItem("Customer-API-Token");
    const refreshToken = localStorage.getItem("authRefreshToken");
    const expiry = localStorage.getItem("tokenExpiry");

    // 1. If we don't even have a refreshToken, they are definitely logged out
    if (!refreshToken) return false;

    // 2. If token exists and is NOT expired, they are good
    const now = Date.now();
    if (token && expiry && now < Number(expiry)) {
      return true;
    }

    // 3. If token is expired BUT we have a refreshToken, return true!
    // This allows the page to load, so fetchAPI can trigger the refresh flow.
    if (refreshToken) {
      console.log(
        "Token expired, but refresh token exists. Allowing access to trigger refresh flow.",
      );
      return true;
    }

    return false;
  }

  const expiryMs = 1775247754000;
  const nowMs = Date.now();
  const diffInMin = (expiryMs - nowMs) / (1000 * 60);

  console.log(`Token expires in ${diffInMin.toFixed(2)} minutes.`);

  const user = hasLoggedIn();

  console.log("routing usertest", usertest);
  console.log("hasLoggedIn", user);
  console.log("localStorage guestUser", localStorage.getItem("guestUser"));
  console.log("reduxGuestUser", reduxGuestUser);
  console.log("routing guestUser", isGuest);
  console.log("routing redirectTo", redirectTo);

  const RootLoginRedirect = ({ user, redirectTo }) => {
    const params = useParams();

    // Fallback chain: params -> pathParts -> localStorage
    const restaurant =
      params.restaurant ||
      currentRestaurant ||
      localStorage.getItem("restaurant");
    const id = params.id || currentRestaurantId;
    const table = params.table || currentTable || localStorage.getItem("table");
    if (configLoading) {
      return null; // Prevents flashing the wrong screen while config loads
    }

    if (restaurant && restaurant !== "undefined")
      localStorage.setItem("restaurant", restaurant);
    if (id && id !== "undefined") localStorage.setItem("restaurantId", id);
    if (table && table !== "undefined") localStorage.setItem("table", table);

    if (user) {
      return <Navigate to={`/${restaurant}/${id}/${table}/menu`} replace />;
    }

    if (redirectTo === "REGISTER") {
      return <Navigate to={`/${restaurant}/${id}/${table}/register`} replace />;
    }

    return <LoginPage packageType={activePackage} />;
  };

  return (
    <Routes>
      <Route path="/:restaurant/:id/takeaway" element={<Navigate to="menu" replace />} />
      <Route path="/:restaurant/:id/takeaway/menu" element={<TakeawayMenuPage />} />
      <Route path="/:restaurant/:id/takeaway/cart" element={<TakeawayCheckout />} />
      <Route path="/:restaurant/:id/takeaway/track" element={<TakeawayStatus />} />
      <Route path="/:restaurant/:id/takeaway/order/:orderId" element={<TakeawayStatus />} />
      {/* <Route path="/:restaurant/:id/:table" element={ user ? <Navigate to={`${window.location.pathname}/menu`} />
            : <LoginPage />}/> */}

      {/* <Route path="/:restaurant/:id/:table" element={user ? ( <Navigate to={`${window.location.pathname}/menu`} />
      ) : redirectTo === "REGISTER" ? ( <Navigate to={`${window.location.pathname}/register`} /> ) : (
      <LoginPage />)
        }
     /> */}

      <Route
        path="/:restaurant/:id/:table"
        element={<RootLoginRedirect user={user} redirectTo={redirectTo} />}
      />

      <Route
        path="/:restaurant/:id/:table/register"
        element={<RegistrationPage />}
      />

      <Route
        path="/:restaurant/:id/:table/menu/item/:menuId"
        element={<ItemDetailPage />}
      />

      {/* <Route path="/:restaurantId/:table" element={<LoginPage />} /> */}

      {isGuest && (
        <>
          <Route path="/:restaurant/:id/:table/menu" element={<MenuPage />} />
        </>
      )}

      {user && (
        <>
          <Route
            path="/:restaurant/:id/:table/profile"
            element={
              <ProtectedLayout>
                <CustomerProfile />
              </ProtectedLayout>
            }
          />

          {/* <Route
                        path="/:restaurantId/:table"
                        element={
                            <ProtectedLayout>
                                <MenuPage />
                            </ProtectedLayout>
                        }
                    /> */}

          <Route
            path="/:restaurant/:id/:table/menu"
            element={
              <ProtectedLayout>
                <MenuPage />
              </ProtectedLayout>
            }
          />

          <Route path="/:restaurant/:id/:table/cart" element={<CartPage />} />

          <Route
            path="/:restaurant/:id/:table/reorder"
            element={
              <ProtectedLayout>
                <ReOrderPage />
              </ProtectedLayout>
            }
          />

          <Route
            path="/:restaurant/:id/:table/pay-bill"
            element={
              <ProtectedLayout>
                <PayBillPage />
              </ProtectedLayout>
            }
          />

          <Route
            path="/:restaurant/:id/:table/waiter-req"
            element={
              <ProtectedLayout>
                <WaiterRequest />
              </ProtectedLayout>
            }
          />

          <Route
            path="/:restaurant/:id/:table/menu/item/:menuId"
            element={
              <ProtectedLayout>
                <ItemDetailPage />
              </ProtectedLayout>
            }
          />

          <Route
            path="/:restaurant/:id/:table/order-placed"
            element={<OrderSuccessPage />}
          />
          <Route
            path="/:restaurant/:id/:table/thank-you"
            element={<PaymentSuccessPage />}
          />
          <Route
            path="/:restaurant/:id/:table/PaymentStatus/:status"
            element={<PaymentStatusPage />}
          />
        </>
      )}

      <Route path="*" element={<PageNotFound />} />
      {/* todo: */}
      {/* <Route path='/:restaurantId/:locationId/menu' element={<MenuPage />} /> 
                <Route path='/:restaurantId/:locationId' element={<RestaurantProfile />} />
                <Route path='/:restaurantId' element={<RestaurantGroupProfile />} />
                 - if above note available - 404 [attractive disgn for "Page Not Found"](With links to navigate other options, including HomePage )

                        - This will help in deep linking to a page. 
                        - Restaurent owner can directly add the deep link to there official website
                        - Or this deep link [maybe, in its short], can be used as SMS or other Marketing strategies
            */}
      {/* Todo: based on restaurantId and locationId, the MenuPage will fetch the menu Item, name, logo */}
      {/* <Route path='/:restaurantId/:categories' element={<MenuPage />} /> */}
    </Routes>
  );
}

export default Router;
